import { render, staticRenderFns } from "./EditColPopOver.vue?vue&type=template&id=45dfd69f&"
import script from "./EditColPopOver.vue?vue&type=script&lang=ts&"
export * from "./EditColPopOver.vue?vue&type=script&lang=ts&"
import style0 from "./EditColPopOver.vue?vue&type=style&index=0&id=45dfd69f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports